import { useIonRouter, UseIonRouterResult } from '@ionic/react'

export type WorkoutType = 'Program' | 'Training'

export const buildTrainingUrl = (
	trainingID: number,
	exerciseOrder: number,
	trainingType: WorkoutType,
	duration?: number,
	suffix?: string
) => {
	let url = `/training/${trainingID}/exercise/${exerciseOrder}`

	if (suffix) {
		url += `/${suffix}`
	}

	const params = new URLSearchParams()
	params.append('workout_type', trainingType)

	if (duration !== undefined) {
		params.append('duration', duration.toString())
	}

	return `${url}?${params.toString()}`
}

export const useGoToTrainingExercise = () => {
	const nav: UseIonRouterResult = useIonRouter()

	return (trainingID: number, exerciseOrder: number, trainingType: WorkoutType) => {
		nav.push(buildTrainingUrl(trainingID, exerciseOrder, trainingType))
	}
}

export const useGoToCardioExecution = () => {
	const nav: UseIonRouterResult = useIonRouter()

	return (trainingID: number, exerciseOrder: number, trainingType: WorkoutType) => {
		nav.push(
			buildTrainingUrl(trainingID, exerciseOrder, trainingType, undefined, 'cardio_execution')
		)
	}
}

export const useGoToCardioRelax = () => {
	const nav: UseIonRouterResult = useIonRouter()

	return (
		trainingID: number,
		exerciseOrder: number,
		trainingType: WorkoutType,
		duration: number
	) => {
		nav.push(
			buildTrainingUrl(trainingID, exerciseOrder, trainingType, duration, 'cardio_relax')
		)
	}
}
